import { isPresent, isBoolean } from "@/lib/utils"

export const showBottomPadding = props =>
  isPresent(props) && isBoolean(props.show_bottom_padding)
    ? props.show_bottom_padding
    : true // Add padding as default

export const getScrollRootElement = () => document

export const ROOT_TREE_ID = "root"
